import { useState } from "react";

import { LEAVE_ICON_NAMES } from "../LeaveTypes/constants/iconsList";
import { ICON_MAP } from "../LeaveTypes/constants/leaveIconMapper";

const ICONS = LEAVE_ICON_NAMES.map((name) => ({
  name,
  Icon: ICON_MAP[name],
}));

type IconItemPropsT = {
  name: string;
  Icon: React.ElementType;
  isSelected?: boolean;
  onClick: (name: string) => void;
};

type LeaveIconsPickerPropsT = {
  selectedIcon: string | null;
  onIconClick: (name: string) => void;
};

const IconItem = ({
  name,
  Icon,
  isSelected = false,
  onClick,
}: IconItemPropsT) => {
  const [hovered, setHovered] = useState(false);

  const handleOnIconClick = () => onClick(name);

  return (
    <button
      type="button"
      className={`flex items-center justify-center p-[.75rem] rounded cursor-pointer w-6 h-6 ${isSelected ? "bg-blue-100" : "bg-gray-100"}`}
      title={name}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={handleOnIconClick}
    >
      <Icon
        size={28}
        className={hovered || isSelected ? "text-secondary-ShadowPCS002" : ""}
        weight={hovered || isSelected ? "fill" : "regular"}
      />
    </button>
  );
};

const LeaveIconsPicker = ({
  selectedIcon,
  onIconClick,
}: LeaveIconsPickerPropsT) => {
  return (
    <div className="grid w-full grid-cols-[repeat(auto-fill,minmax(3rem,1fr))] gap-1">
      {ICONS.map(({ name, Icon }) => (
        <IconItem
          key={name}
          name={name}
          Icon={Icon}
          isSelected={selectedIcon === name}
          onClick={onIconClick}
        />
      ))}
    </div>
  );
};

export default LeaveIconsPicker;
